module.exports = __webpack_public_path__ + "static/avatar-ded55bd82578a4f1e855dd4f8b2e2050.png";